export default "__VITE_ASSET__BB1BzwY9__"